/**
 * ASAŞ Kompozit Panel — Fiyat Hesaplama ve Sepet Yönetimi
 * Varyant metafield: custom.kompozit_baz_fiyat_usd, custom.kompozit_yangin_sinifi vs.
 */

const KompozitHesapla = (() => {

  const KUCUK_PARTI_MIN = 15;
  const KUCUK_PARTI_MAX = 49;
  const KUCUK_PARTI_FARK = 0.35;
  const NANO_FARK = 2.00;
  const DIGITAL_FARK = 1.00;
  const CIFTYUZ_FARK = 1.00;
  const CIFTYUZ_MIN_M2 = 2000;

  let guncelKur = null;
  let seciliVariant = null;

  // Güvenli element erişimi — null dönerse patlamaz
  function el(id) {
    return document.getElementById(id);
  }

  function setText(id, text) {
    var e = el(id);
    if (e) e.textContent = text;
  }

  function setDisplay(id, show) {
    var e = el(id);
    if (e) e.style.display = show ? 'flex' : 'none';
  }

  // ─── Başlatma ───
  function init() {
    if (!el('kompozit-siparis')) return; // Form yoksa çalışma
    _variantDinle();
    _ilkVariantiSec();
    _kurCek();
    _cepheDenetle();
    hesapla();
  }

  // ─── Kur çekme ───
  async function _kurCek() {
    // Yöntem 1: Shopify shop metafield (kur-guncelle script tarafından yazılır)
    try {
      var metaEl = document.querySelector('[data-kompozit-kur]');
      if (metaEl) {
        var k = parseFloat(metaEl.dataset.kompozitKur);
        if (k > 0) { guncelKur = k; setText('kmp-kur', guncelKur.toFixed(4)); hesapla(); return; }
      }
    } catch (e) {}

    // Yöntem 2: Ücretsiz exchange rate API
    try {
      var resp = await fetch('https://open.er-api.com/v6/latest/USD');
      if (resp.ok) {
        var data = await resp.json();
        if (data.rates && data.rates.TRY) {
          guncelKur = data.rates.TRY;
          setText('kmp-kur', guncelKur.toFixed(4));
          hesapla();
          return;
        }
      }
    } catch (e) {}

    // Yöntem 3: Fallback
    if (!guncelKur || isNaN(guncelKur)) {
      guncelKur = 38.50;
    }

    setText('kmp-kur', guncelKur.toFixed(4));
  }

  // ─── Cephe uyarısı ───
  function _cepheDenetle() {
    var cephe = el('kmp-cephe');
    if (cephe && cephe.value === 'false') {
      setDisplay('kmp-uyari-cephe', true);
    }
  }

  // ─── Variant eşleştirme ───
  function _variantDinle() {
    document.querySelectorAll('.kmp-variant-option').forEach(function(sel) {
      sel.addEventListener('change', function() {
        _variantiGuncelle();
        hesapla();
      });
    });
  }

  function _ilkVariantiSec() {
    var sel = el('kmp-variant-id');
    if (sel && sel.options.length > 0) {
      seciliVariant = sel.options[0];
    }
  }

  function _variantiGuncelle() {
    var opts = {};
    document.querySelectorAll('.kmp-variant-option').forEach(function(sel) {
      var idx = parseInt(sel.dataset.optionIndex);
      opts[idx] = sel.value;
    });

    var variantSel = el('kmp-variant-id');
    if (!variantSel) return;

    for (var i = 0; i < variantSel.options.length; i++) {
      var opt = variantSel.options[i];
      var match = true;

      for (var idx in opts) {
        var optKey = 'option' + (parseInt(idx) + 1);
        if (opt.dataset[optKey] !== opts[idx]) {
          match = false;
          break;
        }
      }

      if (match) {
        variantSel.selectedIndex = i;
        seciliVariant = opt;
        return;
      }
    }
  }

  // ─── Ana hesaplama ───
  function hesapla() {
    if (!el('kompozit-siparis')) return;

    if (!seciliVariant) {
      _ilkVariantiSec();
      if (!seciliVariant) return;
    }

    var bazFiyatM2 = parseFloat(seciliVariant.dataset.bazFiyat) || 0;

    var enEl = el('kmp-en');
    var boyEl = el('kmp-boy');
    var adetEl = el('kmp-adet');
    if (!enEl || !boyEl || !adetEl) return;

    var en = parseFloat(enEl.value) || 0;
    var boy = parseFloat(boyEl.value) || 0;
    var adet = parseInt(adetEl.value) || 0;

    var nanoEl = el('kmp-nano');
    var digitalEl = el('kmp-digital');
    var ciftyuzEl = el('kmp-ciftyuz');
    var nano = nanoEl ? nanoEl.checked : false;
    var digital = digitalEl ? digitalEl.checked : false;
    var ciftyuz = ciftyuzEl ? ciftyuzEl.checked : false;

    var m2PerPlaka = (en / 100) * (boy / 100);
    var toplamM2 = parseFloat((m2PerPlaka * adet).toFixed(2));
    var minM2El = el('kmp-min-m2');
    var minM2 = minM2El ? (parseInt(minM2El.value) || 200) : 200;

    setText('kmp-toplam-m2', toplamM2.toFixed(2).replace('.', ','));
    setText('kmp-plaka-sayi', adet.toString());
    setText('kmp-m2-plaka', m2PerPlaka.toFixed(2).replace('.', ','));

    var minOk = toplamM2 >= minM2;
    var kucukPlaka = adet >= KUCUK_PARTI_MIN && adet <= KUCUK_PARTI_MAX;

    setDisplay('kmp-uyari-min', !minOk && toplamM2 > 0);
    setDisplay('kmp-uyari-plaka', kucukPlaka);

    if (ciftyuz && toplamM2 < CIFTYUZ_MIN_M2) {
      setDisplay('kmp-uyari-ciftyuz', true);
    } else {
      setDisplay('kmp-uyari-ciftyuz', false);
    }

    if (bazFiyatM2 === 0 || toplamM2 === 0) {
      setText('kmp-baz-toplam', '—');
      setText('kmp-toplam-usd', '—');
      setText('kmp-toplam-tl', '—');
      setDisplay('kmp-line-plaka', false);
      setDisplay('kmp-line-nano', false);
      setDisplay('kmp-line-digital', false);
      setDisplay('kmp-line-ciftyuz', false);
      _butonGuncelle(false, 'Sepete Ekle');
      return;
    }

    var bazToplam = bazFiyatM2 * toplamM2;
    var plakaFark = kucukPlaka ? KUCUK_PARTI_FARK * toplamM2 : 0;
    var nanoTutar = nano ? NANO_FARK * toplamM2 : 0;
    var digitalTutar = digital ? DIGITAL_FARK * toplamM2 : 0;
    var ciftyuzTutar = ciftyuz ? CIFTYUZ_FARK * toplamM2 : 0;
    var toplamUSD = bazToplam + plakaFark + nanoTutar + digitalTutar + ciftyuzTutar;
    var toplamTL = guncelKur ? toplamUSD * guncelKur : null;

    setText('kmp-baz-m2-label', bazFiyatM2.toFixed(2));
    setText('kmp-baz-toplam', _formatPara(bazToplam, '$'));

    setDisplay('kmp-line-plaka', kucukPlaka);
    if (kucukPlaka) setText('kmp-plaka-fark', _formatPara(plakaFark, '$'));

    setDisplay('kmp-line-nano', nano);
    if (nano) setText('kmp-nano-tutar', _formatPara(nanoTutar, '$'));

    setDisplay('kmp-line-digital', digital);
    if (digital) setText('kmp-digital-tutar', _formatPara(digitalTutar, '$'));

    setDisplay('kmp-line-ciftyuz', ciftyuz);
    if (ciftyuz) setText('kmp-ciftyuz-tutar', _formatPara(ciftyuzTutar, '$'));

    setText('kmp-toplam-usd', _formatPara(toplamUSD, '$'));
    setText('kmp-toplam-tl', toplamTL ? _formatPara(toplamTL, '₺') : '—');

        _butonGuncelle(true, 'Sepete Ekle — ' + _formatPara(toplamTL || toplamUSD, toplamTL ? '₺' : '$'));
  }

  // ─── Buton ───
  function _butonGuncelle(aktif, metin) {
    var btn = el('kmp-sepete-ekle');
    var txt = el('kmp-btn-text');
    if (btn) btn.disabled = !aktif;
    if (txt) txt.textContent = metin;
  }

  // ─── Sepete ekleme ───
  async function sepeteEkle() {
    var btn = el('kmp-sepete-ekle');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    setText('kmp-btn-text', 'Ekleniyor...');

    var variantId = el('kmp-variant-id')?.value;
    var en = parseFloat(el('kmp-en')?.value) || 0;
    var boy = parseFloat(el('kmp-boy')?.value) || 0;
    var adet = parseInt(el('kmp-adet')?.value) || 0;
    var m2PerPlaka = (en / 100) * (boy / 100);
    var toplamM2 = parseFloat((m2PerPlaka * adet).toFixed(2));

    var bazFiyat = parseFloat(seciliVariant?.dataset.bazFiyat) || 0;
    var nano = el('kmp-nano')?.checked || false;
    var digital = el('kmp-digital')?.checked || false;
    var ciftyuz = el('kmp-ciftyuz')?.checked || false;
    var kucukPlaka = adet >= KUCUK_PARTI_MIN && adet <= KUCUK_PARTI_MAX;

    var birimFiyat = bazFiyat;
    if (kucukPlaka) birimFiyat += KUCUK_PARTI_FARK;
    if (nano) birimFiyat += NANO_FARK;
    if (digital) birimFiyat += DIGITAL_FARK;
    if (ciftyuz) birimFiyat += CIFTYUZ_FARK;

    var quantity = Math.ceil(toplamM2);

    var properties = {
      '_en_cm': en.toString(),
      '_boy_cm': boy.toString(),
      '_adet_plaka': adet.toString(),
      '_toplam_m2': toplamM2.toFixed(2),
      '_m2_per_plaka': m2PerPlaka.toFixed(2),
      '_baz_fiyat_usd': bazFiyat.toFixed(2),
      '_birim_fiyat_usd': birimFiyat.toFixed(2),
      '_toplam_fiyat_usd': (birimFiyat * toplamM2).toFixed(2),
      '_kur': guncelKur ? guncelKur.toFixed(4) : 'bekliyor',
      '_renk_kodu': seciliVariant?.dataset.renkKodu || '',
      '_yangin_sinifi': seciliVariant?.dataset.yangin || '',
      '_alum_kalinlik': seciliVariant?.dataset.alumKalinlik || '',
      'Ölçü': en + ' × ' + boy + ' cm',
      'Plaka adedi': adet.toString(),
      'Toplam m²': toplamM2.toFixed(2) + ' m²',
      'Birim fiyat': birimFiyat.toFixed(2) + ' $/m²'
    };

    if (nano) properties['_nano'] = 'evet (+2,00 $/m²)';
    if (digital) properties['_digital_print'] = 'evet (+1,00 $/m²)';
    if (ciftyuz) properties['_cift_yuzey'] = 'evet (+1,00 $/m²)';
    if (kucukPlaka) properties['_kucuk_parti'] = 'evet (+0,35 $/m²)';

    try {
      var resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: quantity,
            properties: properties
          }]
        })
      });

      if (!resp.ok) throw new Error('Sepete eklenemedi');

      setText('kmp-btn-text', 'Eklendi ✓');
      setTimeout(function() {
        btn.disabled = false;
        hesapla();
      }, 2000);

      _sepetSayisiGuncelle();
    } catch (err) {
      console.error('Sepet hatası:', err);
      setText('kmp-btn-text', 'Hata — Tekrar deneyin');
      setTimeout(function() {
        btn.disabled = false;
        hesapla();
      }, 3000);
    }
  }

  // ─── Yardımcılar ───
  function _formatPara(val, simge) {
    return val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ' + simge;
  }

  async function _sepetSayisiGuncelle() {
    try {
      var resp = await fetch('/cart.js');
      var cart = await resp.json();
      var badge = document.querySelector('.cart-count, [data-cart-count], .js-cart-count');
      if (badge) badge.textContent = cart.item_count;
    } catch (e) {}
  }

  // ─── Sayfa yüklenince başlat ───
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Biraz gecikmeyle çalıştır — Shopify section rendering'i bekle
    setTimeout(init, 100);
  }

  return { hesapla: hesapla, sepeteEkle: sepeteEkle };

})();